import Graphic from './graphic'

export default Graphic